const BLOCKS = {
  CLASSICSTRENGTH: {
    name: 'Classic Strength',
    type: 'CLASSICSTRENGTH',
    attributes: {
      block_title: {
        label: 'Block Title',
        value: 'Classic Strength',
        textValue: 'Classic Strength',
        name: 'block_title',
        type: 'text',
        itemName: 'title',
      },
    },
  },
  PILATESR: {
    name: 'Pilates Reformer',
    type: 'PILATESR',
    attributes: {
      block_title: {
        label: 'Block Title',
        value: 'Pilates Reformer',
        textValue: 'Pilates Reformer',
        name: 'block_title',
        type: 'text',
        itemName: 'title',
      },
    },
  },
  AMRAP: {
    name: 'AMRAP',
    type: 'AMRAP',
    fullName: 'As Many Rounds As Possible',
    attributes: {
      totalTime: {
        label: 'Total Time (mm:ss)',
        shortLabel: 'Total Time',
        value: '00:01:00',
        name: 'totalTime',
        type: 'clock',
        itemName: 'Total',
      },
    },
  },
  RFT: {
    name: 'Work for Time',
    type: 'RFT',
    attributes: {
      rounds: {
        label: 'Number of Rounds',
        value: 3,
        name: 'rounds',
        itemName: 'rounds',
      },
    },
  },
  RNFT: {
    name: 'Work not for Time',
    type: 'RNFT',
    attributes: {
      rounds: {
        label: 'Number of Rounds',
        value: 3,
        name: 'rounds',
        itemName: 'rounds',
      },
    },
  },
  INTERVALS: {
    name: 'Work/Rest',
    type: 'INTERVALS',
    // uniqueExercises: true,
    valueAttribute: 'intervals',
    // indexPrefix: 'Interval',
    attributes: {
      intervals: {
        label: 'Number of Rounds',
        value: 3,
        name: 'intervals',
        itemName: 'rounds',
      },
      workTime: {
        label: 'Work Time',
        value: '00:00:40',
        type: 'clock',
        name: 'workTime',
        itemName: 'Work Time',
      },
      restTime: {
        label: 'Rest Time',
        value: '00:00:20',
        type: 'clock',
        name: 'restTime',
        itemName: 'Rest Time',
      },
    },
  },
  STRENGTH: {
    name: 'Strength Sets',
    type: 'STRENGTH',
    attributes: {
      sets: {
        label: 'Number of Sets',
        value: 3,
        name: 'sets',
        itemName: 'Sets',
      },
      interval: {
        label: 'Rest Time (mm:ss)',
        shortLabel: 'Rest Time',
        value: '00:01:00',
        name: 'interval',
        asNeeded: false,
        type: 'clock',
        itemName: 'Rest Time',
      },
    },
  },
  SUPERSETS: {
    name: 'Super Sets',
    type: 'SUPERSETS',
    attributes: {
      sets: {
        label: 'Number of Sets',
        value: 3,
        name: 'sets',
        itemName: 'Sets',
      },
      interval: {
        label: 'Rest Time (mm:ss)',
        shortLabel: 'Rest Time',
        value: '00:01:00',
        name: 'interval',
        asNeeded: false,
        type: 'clock',
        itemName: 'Rest Time',
      },
    },
  },
  // QUALITYSETS: {
  //   name: 'Quality Sets',
  //   type: 'QUALITYSETS',
  //   attributes: {
  //     sets: {
  //       label: 'Number of Sets',
  //       value: 3,
  //       name: 'sets',
  //       itemName: 'Sets',
  //     },
  //   },
  // },
  EMOM: {
    name: 'EMOM',
    type: 'EMOM',
    attributes: {
      roundTime: {
        label: 'Round Time (mm:ss)',
        shortLabel: 'Round Time',
        value: '00:01:00',
        name: 'roundTime',
        type: 'clock',
        itemName: 'Total',
      },
      rounds: {
        label: 'Number of Rounds',
        value: 3,
        name: 'rounds',
        itemName: 'rounds',
      },
    },
  },
  RUN: {
    name: 'Run',
    type: 'RUN',
    // nullableAttributes: ['pace'],
    attributes: {
      rounds: {
        label: 'Number of Rounds',
        value: 1,
        name: 'rounds',
        itemName: 'rounds',
      },
      block_title: {
        label: 'Block Title',
        value: 'Run',
        textValue: 'Run',
        name: 'block_title',
        type: 'text',
        itemName: 'title',
      },
      // unit: {
      //   label: 'Unit',
      //   value: null,
      //   textValue: 'Time',
      //   name: 'unit',
      //   type: 'clock',
      //   itemName: 'Unit',
      // },
      // pace: {
      //   label: 'Pace (optional)',
      //   value: null,
      //   name: 'pace',
      //   type: 'nullable',
      //   itemName: 'Pace',
      //   textValue: 'km/h',
      // },
    },
  },
  REST: {
    name: 'Rest',
    type: 'REST',
    attributes: {
      rest: {
        label: 'Rest Time (mm:ss)',
        shortLabel: 'Rest Time',
        value: '00:01:00',
        name: 'rest',
        type: 'clock',
        itemName: 'Rest',
      },
      block_title: {
        label: 'Block Title',
        value: 'Rest',
        textValue: 'Rest',
        name: 'block_title',
        type: 'text',
        itemName: 'title',
      },
    },
  },
  CUSTOM: {
    name: 'Custom',
    type: 'CUSTOM',
    attributes: {
      block_title: {
        label: 'Block Title',
        value: 'Custom',
        textValue: 'Custom',
        name: 'block_title',
        type: 'text',
        itemName: 'title',
      },
      text: {
        label: 'Description',
        value: '',
        textValue: '',
        name: 'text',
        type: 'text',
        itemName: 'Text',
      },
    },
  },
};

export default BLOCKS;
